import { ShieldAlert } from 'lucide-react';
import SodRulesPanel from './AiCopilot/SodRulesPanel';

export default function SodRulesPage() {
  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <header className="flex items-start gap-4">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-rose-500 to-rose-700 text-white shadow">
          <ShieldAlert className="h-6 w-6" />
        </div>
        <div className="flex-1 min-w-0">
          <h1 className="text-2xl font-bold text-slate-900">SoD rules</h1>
        </div>
      </header>
      <SodRulesPanel embedded={false} />
    </div>
  );
}
